/**
 * UpgradePrompt — the web upgrade offer, or the native locked state.
 *
 * `lockedTitle` is required so every host decides what native says: a noun
 * phrase for the feature, because `headline` ("Unlock Portfolio Tracking") is a
 * call to action and cannot be shown in a 3.1.3(f) companion app.
 */

import React from 'react';
import { COMMERCE_ENABLED } from '@/lib/commerce/policy';
import { PlanLockedNotice } from '@/components/commerce/PlanLockedNotice';
import { UpgradeOffer, type UpgradeOfferProps } from './UpgradeOffer';

export interface UpgradePromptProps extends UpgradeOfferProps {
  lockedTitle: string;
}

export function UpgradePrompt({ lockedTitle, ...offer }: UpgradePromptProps) {
  if (!COMMERCE_ENABLED) {
    return <PlanLockedNotice variant={offer.variant ?? 'card'} title={lockedTitle} />;
  }
  return <UpgradeOffer {...offer} />;
}
